import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { BLOCKS } from '@contentful/rich-text-types';
import { getArticleBySlug } from '../utils/articleStorage';
import { formatDate } from '../utils/formatDate';
import './ArticlePage.css';

function ArticlePage() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [article, setArticle] = useState(null);
  const [notFound, setNotFound] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchArticle = async () => {
      setLoading(true);
      const foundArticle = await getArticleBySlug(slug);
      if (foundArticle) {
        setArticle(foundArticle);
      } else {
        setNotFound(true);
      }
      setLoading(false);
    };
    fetchArticle();
  }, [slug]);

  const handleBack = () => {
    navigate('/');
  };

  const renderOptions = {
    renderNode: {
      [BLOCKS.EMBEDDED_ASSET]: (node) => {
        const { file, title, description } = node.data.target.fields;
        const imageUrl = file?.url ? `https:${file.url}` : null;

        if (!imageUrl) return null;

        return (
          <div className="embedded-image">
            <img
              src={imageUrl}
              alt={description || title || 'Embedded image'}
            />
            {description && <p className="image-caption">{description}</p>}
          </div>
        );
      },
    },
  };

  if (loading) {
    return (
      <div className="article-page">
        <div className="article-loading">loading...</div>
      </div>
    );
  }

  if (notFound) {
    return (
      <div className="article-page">
        <div className="article-not-found">
          <h1>article not found</h1>
          <p>the article you're looking for doesn't exist.</p>
          <button className="back-button" onClick={handleBack}>
            ← back to home
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="article-page">
      <div className="article-actions">
        <button className="back-button" onClick={handleBack}>
          ← back to home
        </button>
      </div>

      <article className="article-content">
        {article.image && (
          <div className="article-image-container">
            <img
              src={article.image}
              alt={article.title}
              className="article-image"
            />
          </div>
        )}
        <h1 className="article-title">{article.title.toLowerCase()}</h1>
        <p className="article-date">{formatDate(article.date)}</p>
        <div className="article-body">
          {article.content && documentToReactComponents(article.content, renderOptions)}
        </div>
      </article>
    </div>
  );
}

export default ArticlePage;
